import { useState } from "react";
import { api } from "../api/client";
import { useAuthStore } from "../stores/auth";

interface Props {
  symbol: string;
  refPrice: number;
}

export function OrderEntry({ symbol, refPrice }: Props) {
  const isAuthed = !!useAuthStore((s) => s.accessToken);
  const [side, setSide] = useState<"buy" | "sell">("buy");
  const [type, setType] = useState<"market" | "limit">("market");
  const [qty, setQty] = useState("0.01");
  const [price, setPrice] = useState(refPrice.toFixed(2));
  const [preview, setPreview] = useState<{ notional: number; estimated_fee: number } | null>(null);
  const [status, setStatus] = useState<string | null>(null);

  async function onPreview() {
    setStatus(null);
    try {
      const data = await api<{ notional: number; estimated_fee: number }>("/v1/orders/preview", {
        method: "POST",
        body: {
          symbol,
          side,
          type,
          quantity: parseFloat(qty),
          price: type === "limit" ? parseFloat(price) : undefined,
        },
      });
      setPreview(data);
    } catch (e) {
      setStatus((e as Error).message);
    }
  }

  async function onSubmit() {
    setStatus(null);
    try {
      const data = await api<{ id: string; status: string }>("/v1/orders/route", {
        method: "POST",
        body: {
          symbol,
          side,
          type,
          quantity: parseFloat(qty),
          price: type === "limit" ? parseFloat(price) : undefined,
        },
      });
      setStatus(`Order ${data.id} ${data.status}`);
    } catch (e) {
      setStatus((e as Error).message);
    }
  }

  return (
    <div className="order-entry">
      <h4>Order entry</h4>
      <div className="order-tabs">
        <button
          type="button"
          className={side === "buy" ? "tab tab-buy active" : "tab tab-buy"}
          onClick={() => setSide("buy")}
        >
          Buy
        </button>
        <button
          type="button"
          className={side === "sell" ? "tab tab-sell active" : "tab tab-sell"}
          onClick={() => setSide("sell")}
        >
          Sell
        </button>
      </div>
      <label>
        Type
        <select value={type} onChange={(e) => setType(e.target.value as "market" | "limit")}>
          <option value="market">Market</option>
          <option value="limit">Limit</option>
        </select>
      </label>
      <label>
        Quantity
        <input value={qty} onChange={(e) => setQty(e.target.value)} inputMode="decimal" />
      </label>
      {type === "limit" && (
        <label>
          Price
          <input value={price} onChange={(e) => setPrice(e.target.value)} inputMode="decimal" />
        </label>
      )}
      <div className="order-actions">
        <button type="button" className="btn btn-ghost" onClick={onPreview}>
          Preview
        </button>
        <button
          type="button"
          className={`btn ${side === "buy" ? "btn-buy" : "btn-sell"}`}
          onClick={onSubmit}
          disabled={!isAuthed}
        >
          {isAuthed ? `Route ${side}` : "Sign in to trade"}
        </button>
      </div>
      {preview && (
        <div className="order-preview">
          notional ${preview.notional.toFixed(2)} · est fee ${preview.estimated_fee.toFixed(4)}
        </div>
      )}
      {status && <div className="order-status">{status}</div>}
      <p className="order-disclaimer">
        Phase 1 stub gateway. No external venue is contacted.
      </p>
    </div>
  );
}
